import cn from "clsx";
import { jsx as _jsx } from "react/jsx-runtime";
var CategoryChip = function CategoryChip(_ref) {
  var label = _ref.label,
    selected = _ref.selected,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    className: cn('tw-w-auto tw-mr-0.8',
    // Font
    'tw-font-body5',
    // Flex
    'tw-flex-none',
    // Rounded
    'tw-rounded-2',
    // Clamp
    'tw-clamp-1',
    // Padding
    'tw-px-1.2 tw-py-0.8',
    // Margin
    'tw-mb-0.8',
    // Transition
    'tw-transition-colors tw-duration-150 tw-ease-in-out',
    // Border
    'tw-border tw-border-solid', selected ? 'tw-bg-primary-light-400 dark:tw-bg-secondary-dark-400 tw-text-neutral-light-100 dark:tw-text-neutral-light-800 tw-border-transparent' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500 tw-border-neutral-light-600 dark:tw-border-neutral-dark-500'),
    onClick: onClick,
    children: label
  });
};
CategoryChip.displayName = 'CategoryChip';
export default CategoryChip;